import * as Sentry from '@sentry/react'

import { sentry as sentryConfig } from '@/config/sentry'

Sentry.init({ ...sentryConfig })
